let events = {};

export default {
  on: function (eventName, fn) {
    if (!events[eventName]) {
      events[eventName] = [];
    }

    events[eventName].push(fn);

    return () => {
      let idx = events[eventName].indexOf(fn);
      delete events[eventName][idx];
    };
  },

  trigger: function (eventName, data = {}) {
    if (events[eventName]) {
      events[eventName].forEach((fn) => fn(data));
    }
  },
};
